const originalFetch = window.fetch.bind(window);

const esLlamadaApi = (input) => {
  const url = typeof input === 'string' ? input : input.url;
  return url.includes('/api/') || url.startsWith('/api');
};

window.fetch = async (input, init = {}) => {
  if (esLlamadaApi(input)) {
    const token = localStorage.getItem('token');
    init = {
      ...init,
      headers: { ...(init.headers || {}), ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    };
  }
  const response = await originalFetch(input, init);
  if (response.status === 401 && esLlamadaApi(input)) {
    localStorage.removeItem('token');
    localStorage.removeItem('usuarioActual');
    window.location.reload();
  }
  return response;
};

export const setSesion = (token, usuario) => {
  localStorage.setItem('token', token);
  localStorage.setItem('usuarioActual', JSON.stringify(usuario));
};

export const limpiarSesion = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('usuarioActual');
};

export const getUsuarioActual = () => {
  try {
    return JSON.parse(localStorage.getItem('usuarioActual') || 'null');
  } catch {
    return null;
  }
};
